<template>
  <div class="w-1/4 p-6 bg-white rounded-md">
    <div class="flex items-center justify-between align-center">
      <div class="flex items-start justify-start gap-4 align-start">
        <img
          class="w-16 h-16 rounded-full"
          src="../../assets/avatar.jpg"
          alt=""
        />
        <div class="flex flex-col items-start font-medium dark:text-white">
          <div class="text-black">{{ post.user.name }}</div>
          <div class="text-sm text-gray-500 dark:text-gray-400">
            Joined in {{ formatDateSimple(post.user.created_at) }}
          </div>
        </div>
      </div>
      <button>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
        >
          <path
            d="M12 27C13.6569 27 15 25.6569 15 24C15 22.3431 13.6569 21 12 21C10.3431 21 9 22.3431 9 24C9 25.6569 10.3431 27 12 27Z"
            fill="black"
          />
          <path
            d="M24 27C25.6569 27 27 25.6569 27 24C27 22.3431 25.6569 21 24 21C22.3431 21 21 22.3431 21 24C21 25.6569 22.3431 27 24 27Z"
            fill="black"
          />
          <path
            d="M36 27C37.6569 27 39 25.6569 39 24C39 22.3431 37.6569 21 36 21C34.3431 21 33 22.3431 33 24C33 25.6569 34.3431 27 36 27Z"
            fill="black"
          />
        </svg>
      </button>
    </div>
    <p class="my-6 text-justify text-gray-500">
      {{ post.description }}
    </p>
    <div class="flex justify-between text-black">
      <button>Voir plus</button>
      <p>Posté le {{ formatDate(post.created_at) }}</p>
    </div>
    <div class="h-1 my-6 bg-black rounded"></div>

    <div class="flex justify-between">
      <div class="flex gap-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M12.5 8.33339L11.6783 8.19673C11.6585 8.31606 11.6649 8.43827 11.697 8.55489C11.7292 8.6715 11.7863 8.77972 11.8645 8.87202C11.9427 8.96432 12.0401 9.0385 12.1498 9.08939C12.2595 9.14028 12.379 9.16667 12.5 9.16673V8.33339ZM3.33333 8.33339V7.50006C3.11232 7.50006 2.90036 7.58786 2.74408 7.74414C2.5878 7.90042 2.5 8.11238 2.5 8.33339H3.33333ZM5 17.5001H14.4667V15.8334H5V17.5001ZM15.4667 7.50006H12.5V9.16673H15.4667V7.50006ZM13.3225 8.47006L13.9933 4.44089L12.35 4.16673L11.6783 8.19673L13.3225 8.47006ZM12.35 2.50006H12.1717V4.16673H12.35V2.50006ZM9.3975 3.98423L7.3025 7.12923L8.68917 8.05423L10.7858 4.90923L9.3975 3.98423ZM6.60833 7.50006H3.33333V9.16673H6.60833V7.50006ZM2.5 8.33339V15.0001H4.16667V8.33339H2.5ZM16.9183 15.4901L17.9183 10.4901L16.285 10.1634L15.285 15.1634L16.9183 15.4901ZM7.3025 7.12923C7.22638 7.24332 7.12243 7.33687 7.00149 7.40156C6.88054 7.46625 6.74549 7.50008 6.60833 7.50006V9.16673C7.01989 9.1667 7.42507 9.06506 7.78792 8.87085C8.15077 8.67663 8.46006 8.39584 8.68833 8.05339L7.3025 7.12923ZM13.9933 4.44089C14.0331 4.20218 14.0205 3.95765 13.9562 3.72432C13.892 3.49098 13.7777 3.27444 13.6213 3.08974C13.4649 2.90504 13.2702 2.75662 13.0507 2.65478C12.8311 2.55295 12.592 2.50015 12.35 2.50006V4.16673L13.9933 4.44089ZM15.4667 9.16673C15.59 9.16668 15.7118 9.194 15.8232 9.24671C15.9347 9.29943 16.0331 9.37623 16.1113 9.47157C16.1895 9.56691 16.2456 9.67842 16.2755 9.79806C16.3054 9.9177 16.3092 10.0425 16.285 10.1634L17.9183 10.4901C17.9908 10.1274 17.9819 9.75325 17.8924 9.39446C17.8028 9.03568 17.6347 8.70123 17.4003 8.41524C17.1659 8.12924 16.8709 7.89881 16.5367 7.74055C16.2025 7.5823 15.8373 7.50016 15.4675 7.50006L15.4667 9.16673ZM14.4667 17.5001C15.0447 17.5001 15.6049 17.2998 16.0519 16.9334C16.4988 16.5669 16.805 16.0569 16.9183 15.4901L15.285 15.1634C15.2472 15.3525 15.145 15.5227 14.9957 15.6449C14.8465 15.767 14.6595 15.8337 14.4667 15.8334V17.5001ZM12.1717 2.50006C11.6229 2.50007 11.0827 2.63554 10.5989 2.89445C10.1151 3.15335 9.7019 3.52769 9.3975 3.98423L10.7858 4.90923C10.938 4.68088 11.1433 4.49363 11.3852 4.3641C11.6271 4.23458 11.8973 4.16678 12.1717 4.16673V2.50006ZM5 15.8334C4.77899 15.8334 4.56702 15.7456 4.41074 15.5893C4.25446 15.433 4.16667 15.2211 4.16667 15.0001H2.5C2.5 15.6631 2.76339 16.299 3.23223 16.7678C3.70107 17.2367 4.33696 17.5001 5 17.5001V15.8334Z"
            fill="#B5B5B5"
          />
          <path
            d="M6.66663 8.33337V16.6667"
            stroke="#B5B5B5"
            stroke-width="1.66667"
          />
        </svg>
        <span class="text-black">54</span>
      </div>
      <div class="flex gap-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M2.88663 14.0234C1.66663 13.0476 1.66663 12.3092 1.66663 9.16673C1.66663 6.02423 1.66663 4.45256 2.88663 3.47673C4.10829 2.50006 6.07163 2.50006 9.99996 2.50006C13.9283 2.50006 15.8925 2.50006 17.1125 3.47673C18.3333 4.45256 18.3333 6.02423 18.3333 9.16673C18.3333 12.3092 18.3333 13.0476 17.1125 14.0234C15.8933 15.0001 13.9283 15.0001 9.99996 15.0001C7.90829 15.0001 6.83329 16.4484 4.99996 17.5001V14.8234C4.08829 14.6876 3.41746 14.4484 2.88663 14.0234Z"
            stroke="#B5B5B5"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="text-black">154</span>
      </div>
      <div class="flex gap-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M18.1633 8.7883L14.4133 12.5383C14.2372 12.7144 13.9983 12.8134 13.7492 12.8134C13.5001 12.8134 13.2613 12.7144 13.0852 12.5383C12.909 12.3622 12.8101 12.1233 12.8101 11.8742C12.8101 11.6252 12.909 11.3863 13.0852 11.2102L15.2344 9.06252H12.8906C11.4354 9.06204 10.0213 9.54528 8.87064 10.4362C7.72002 11.3272 6.89819 12.5754 6.53438 13.9844C6.5036 14.1036 6.44964 14.2156 6.37558 14.314C6.30152 14.4123 6.20882 14.4951 6.10275 14.5577C5.99669 14.6202 5.87935 14.6612 5.75743 14.6784C5.63551 14.6956 5.5114 14.6886 5.39219 14.6578C5.27297 14.627 5.16099 14.5731 5.06262 14.499C4.96426 14.425 4.88145 14.3323 4.81891 14.2262C4.75638 14.1201 4.71535 14.0028 4.69816 13.8809C4.68098 13.759 4.68797 13.6349 4.71875 13.5156C5.18576 11.7037 6.24214 10.0985 7.72158 8.9529C9.20102 7.80725 11.0195 7.1862 12.8906 7.18751H15.2344L13.0867 5.03751C12.9106 4.86139 12.8117 4.62252 12.8117 4.37345C12.8117 4.12438 12.9106 3.88551 13.0867 3.70939C13.2628 3.53327 13.5017 3.43433 13.7508 3.43433C13.9999 3.43433 14.2387 3.53327 14.4148 3.70939L18.1648 7.45939C18.2523 7.5466 18.3216 7.65023 18.3688 7.76431C18.4161 7.87839 18.4403 8.00069 18.4402 8.12417C18.44 8.24765 18.4155 8.36989 18.368 8.48386C18.3205 8.59783 18.2509 8.70129 18.1633 8.7883ZM15 15.9375H3.4375V6.87501C3.4375 6.62637 3.33873 6.38792 3.16291 6.2121C2.9871 6.03629 2.74864 5.93751 2.5 5.93751C2.25136 5.93751 2.0129 6.03629 1.83709 6.2121C1.66127 6.38792 1.5625 6.62637 1.5625 6.87501V16.875C1.5625 17.1237 1.66127 17.3621 1.83709 17.5379C2.0129 17.7137 2.25136 17.8125 2.5 17.8125H15C15.2486 17.8125 15.4871 17.7137 15.6629 17.5379C15.8387 17.3621 15.9375 17.1237 15.9375 16.875C15.9375 16.6264 15.8387 16.3879 15.6629 16.2121C15.4871 16.0363 15.2486 15.9375 15 15.9375Z"
            fill="#B5B5B5"
          />
        </svg>
        <span class="text-black">14</span>
      </div>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from "date-fns";

export default {
  props: {
    post: Object,
  },
  setup() {
    const formatDate = (dateString) => {
      try {
        const date = parseISO(dateString);
        return format(date, "dd MMM yyyy, HH:mm"); // Format : 08 Aug 2024, 16:55
      } catch (error) {
        console.error("Invalid date:", dateString);
        return dateString;
      }
    };
    const formatDateSimple = (dateString) => {
      try {
        const date = parseISO(dateString);
        return format(date, "dd MMM yyyy"); // Format : 08 Aug 2024,
      } catch (error) {
        console.error("Invalid date:", dateString);
        return dateString;
      }
    };
    return { formatDate, formatDateSimple };
  },
};
</script>
